import React from 'react';
import { ExternalLink, Star, MessageCircle } from 'lucide-react';
import styles from './ProductCard.module.css';
import { colors } from '../styles/colors';

// Función para resumir texto manteniendo oraciones completas
function summarizeText(text, maxLength = 150) {
    if (!text || text === 'Sin información') return 'No disponible';
    if (text.length <= maxLength) return text;
    const truncated = text.substring(0, maxLength);
    const lastPeriod = Math.max(
        truncated.lastIndexOf('. '),
        truncated.lastIndexOf('; ')
    );
    if (lastPeriod > 0) {
        return text.substring(0, lastPeriod + 1);
    }
    const lastSpace = truncated.lastIndexOf(' ');
    return text.substring(0, lastSpace) + '...';
}

// Función para extraer características clave
function extractKeyCharacteristics(characteristics) {
    if (!characteristics || characteristics === 'Sin información') return 'No disponible';
    let cleaned = characteristics
        .replace(/tiene las siguientes características:?/i, '')
        .replace(/se caracteriza por:?/i, '')
        .replace(/^[^:]+:\s*/, '');
    const items = cleaned
        .split(/[,.;]/)
        .map(item => item.trim())
        .filter(item => item && !item.toLowerCase().includes('sin información') && item.length > 3);
    const selectedItems = items
        .sort((a, b) => (a.length !== b.length ? a.length - b.length : a.localeCompare(b)))
        .slice(0, Math.min(3, items.length));
    return selectedItems.join(', ') || 'No disponible';
}

export function ProductCard({ product, onFavorite, isFavorite }) {
    const whatsappNumber = "+573103275528";
    const whatsappMessage = `Hola, estoy interesado en el producto ${product.name}. ¿Podrían brindarme más información?`;
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <h3 className={styles.title} style={{ color: colors.primary.blue }}>
                    {product.name}
                </h3>
                {/* <button
          onClick={() => onFavorite(product)}
          className={styles.favoriteButton}
          style={{ color: isFavorite ? '#FFB800' : colors.gray[700] }}
        >
          <Star size={20} fill={isFavorite ? 'currentColor' : 'none'} />
        </button> */}
            </div>

            <div className={styles.infoList}>
                <div>
                    <span className={styles.label}>INCI:</span>
                    <p className={styles.value}>{product.inci || 'No disponible'}</p>
                </div>
                <div>
                    <span className={styles.label}>Descripción:</span>
                    <p className={styles.value}>{summarizeText(product.description)}</p>
                </div>
                <div>
                    <span className={styles.label}>Características:</span>
                    <p className={styles.value}>{extractKeyCharacteristics(product.characteristics)}</p>
                </div>
                <div>
                    <span className={styles.label}>Sector:</span>
                    <p className={styles.value}>{product.sector}</p>
                </div>
            </div>

            <div className={styles.actions}>
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.actionButton}
                    style={{ background: colors.primary.blue }}
                >
                    <MessageCircle size={18} className={styles.iconMargin} />
                    Contactar vendedor
                </a>
                {product.webLink && (
                    <a
                        href={product.webLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.actionButton}
                        style={{ background: colors.primary.lightBlue }}
                    >
                        <ExternalLink size={18} className={styles.iconMargin} />
                        Más información
                    </a>
                )}
            </div>
        </div>
    );
}
